import React, {Component} from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';
import ProductStepper from './ProductStepper';
import ProductHeader from './ProductHeader';
import ProductCardGroup from './ProductCardGroup';
import DialogChooseBanner from './DialogChooseBanner';

import banners from '../data/whiteboards';
import letters from '../data/letters';
import letterCombinations from '../data/letterCombinations';
import shapes from '../data/shapes';
import clipart from '../data/clipart';

class ProductsOverlay extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeStep: 'SHAPES', // BANNERS, LETTERS, SHAPES, CLIPART
      showDialogChooseBanner: false,
      filters: {
        letters: {
          fontStyle: [],
        },
        letterCombinations: {
          pattern: [],
        },
        shapes: {
          type: [],
        },
        clipart: {
          category: [],
        },
      },
    };
  }

  handleClickStep = (stepName) => {
    this.setState({
      activeStep: stepName,
    });
  };

  handleCloseDialogChooseBanner = () => {
    this.setState({
      showDialogChooseBanner: false,
    });
  };

  handleClickActionBtn = (productId, model) => {
    if (this.props.banner || model.type === 'BANNER') {
      this.props.onClickActionBtn(productId, model);
    } else {
      this.setState({
        showDialogChooseBanner: true,
      });
    }
  };

  handleRemoveFilter = (filter) => {
    this.setState(
      update(this.state, {
        filters: {
          [filter.product]: {
            [filter.attr]: {
              $set: this.state.filters[filter.product][filter.attr].filter((val) => val !== filter.value),
            },
          },
        },
      }),
    );
  };

  applyFilter(toFilter, filters, filterKey) {
    const filtered = JSON.parse(JSON.stringify(toFilter));
    Object.keys(toFilter).forEach((key) => {
      const item = toFilter[key];
      if (filters[filterKey].length && !filters[filterKey].includes(item[filterKey])) {
        delete filtered[key];
      }
    });
    return filtered;
  }

  handleSetFilters = (product, attr, filters) => {
    this.setState(
      update(this.state, {
        filters: {
          [product]: {
            [attr]: {
              $set: filters,
            },
          },
        },
      }),
    );
  };

  renderCardGroup() {
    const activeStep = this.state.activeStep;
    const cardGroupProps = {
      onClickActionBtn: this.handleClickActionBtn,
      banner: this.props.banner,
    };

    if (activeStep === 'BANNERS') {
      return <ProductCardGroup products={banners} {...cardGroupProps} />;
    } else if (activeStep === 'LETTERS') {
      // this.applyFilter(letters, this.state.filters.letters, 'fontStyle');
      return (
        <ProductCardGroup
          products={this.applyFilter(letters, this.state.filters.letters, 'fontStyle')}
          {...cardGroupProps}
        />
      );
    } else if (activeStep === 'SHAPES') {
      return (
        <ProductCardGroup products={this.applyFilter(shapes, this.state.filters.shapes, 'type')} {...cardGroupProps} />
      );
    } else if (activeStep === 'CLIPART') {
      return (
        <ProductCardGroup
          products={this.applyFilter(clipart, this.state.filters.clipart, 'category')}
          {...cardGroupProps}
        />
      );
    } else if (activeStep === 'LETTER_COMBINATIONS') {
      return (
        <ProductCardGroup
          products={this.applyFilter(letterCombinations, this.state.filters.letterCombinations, 'pattern')}
          {...cardGroupProps}
        />
      );
    }
  }

  render() {
    const {activeStep} = this.state;

    return (
      <div className="products-overlay disable-dbl-tap-zoom">
        <DialogChooseBanner open={this.state.showDialogChooseBanner} handleClose={this.handleCloseDialogChooseBanner} />

        <ProductStepper
          onClickStep={this.handleClickStep}
          onClickClose={this.props.onClickClose}
          activeStep={activeStep}
        />

        <ProductHeader
          activeStep={activeStep}
          filters={this.state.filters}
          removeFilter={this.handleRemoveFilter}
          setFilter={this.handleSetFilters}
        />

        {this.renderCardGroup()}
      </div>
    );
  }
}

ProductsOverlay.propTypes = {
  onClickClose: PropTypes.func.isRequired,
  onClickActionBtn: PropTypes.func.isRequired,
  banner: PropTypes.string,
};

export default ProductsOverlay;
